import { render } from "./CookiePolicy.vue?vue&type=template&id=f832199e"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__